import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },

  {
    path: '/hero',
    name: 'Hero',
    component: () => import('../views/Hero'),
  },

  {
    path: '/users',
    name: 'Users',
    meta: {
      title: 'Usuarios',
    },
    component: () => import('../views/Users'),
  },

  {
    path: '/claims',
    name: 'Claims',
    meta: {
      title: 'Reclamos',
    },
    component: () => import('../views/Claims'),
  },

  {
    path: '/claims/:id',
    name: 'Claim',
    meta: {
      title: 'Reclamo',
    },
    component: () => import('../views/ClaimView'),
  },

  {
    path: '/chat/:claimId',
    name: 'Chat',
    meta: {
      title: 'Chat',
    },
    component: () => import('../views/Chat'),
  },

  {
    path: '/profile',
    name: 'Profile',
    meta: {
      title: 'Mi Perfil',
    },
    component: () => import('../views/Profile'),
  },

  {
    path: '/claim',
    name: 'ClaimNew',
    meta: {
      title: 'Nuevo Reclamo',
    },
    component: () => import('../views/Claim'),
  },

  {
    path: '/claim/:claimId',
    name: 'ClaimEdit',
    meta: {
      title: 'Reclamo',
    },
    component: () => import('../views/Claim'),
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

import { isAuthenticated } from '@/auth.js'

router.beforeEach((to, from, next) => {
  if (to.name === 'Login' && isAuthenticated()) {
    return next({ name: 'Claims' })
  }

  if (to.name !== 'Login' && !isAuthenticated()) {
    return next('/')
  }

  next()
})

export default router
